import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[englishNumberOnly]',
  standalone: true
})
export class EnglishNumberOnlyDirective {
  @Input() englishNumberOnly: boolean = true;
  private readonly persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  private readonly arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];

  constructor(private el: ElementRef<HTMLInputElement>) {
  }

  @HostListener('input', ['$event'])
  onInput(e: Event) {
    if (!this.englishNumberOnly) {
      return;
    }
    const inputEl = this.el.nativeElement;
    let value = inputEl.value || '';
    // Convert Persian/Arabic digits → English
    this.persianDigits.forEach((d, i) => value = value.replaceAll(d, i.toString()));
    this.arabicDigits.forEach((d, i) => value = value.replaceAll(d, i.toString()));
    // Keep only 0–9 (ASCII digits)
    value = value.replace(/[^0-9]/g, '');
    if (inputEl.value !== value) {
      inputEl.value = value;
      inputEl.dispatchEvent(new Event('input', {bubbles: true}));
    }
  }
}
